import React from 'react';
import PropTypes from 'prop-types';

class DiscountCode extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            isVisible: this.props.discountCode.length > 0,
        }

        this.afterHide = this.props.afterHide ? this.props.afterHide : () => {}
        this.afterShow = this.props.afterHide ? this.props.afterHide : () => {}

        this.handleTextClick = this.handleTextClick.bind(this)
    }

    handleTextClick() {
        if (this.state.isVisible && this.props.discountCode.length > 0) {
            this.afterHide()
        }

        this.setState(prevState => ({
            isVisible: !prevState.isVisible
        }))

        this.afterShow()
    }

    render() {
        const discountCode = this.props.discountCode
        const isValid = this.props.isValid
        const onChange = this.props.onChange
        const isVisible = this.state.isVisible || discountCode.length > 0
        const text = !isVisible ? 'Do you have a discount code?' : 'I don\'t have a discount code'

        return (
            <div className="discount-wrp">
                <div>
                <span className="discount__link" onClick={this.handleTextClick}>
                    {text}
                </span>
                    <div className={isVisible ? "discount__code open" : "discount__code"}>
                        <label htmlFor="promo">Discount code</label>
                        <div className="input-wrap">
                            <input className={discountCode.length > 0 && !isValid ? 'discount__code--error' : ''}
                                   id="promo"
                                   name="promo"
                                   type="text"
                                   size="20"
                                   value={discountCode}
                                   onChange={onChange} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


DiscountCode.propTypes = {
    discountCode: PropTypes.string.isRequired,
    isValid: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    afterShow: PropTypes.func,
    afterHide: PropTypes.func,
};

export default DiscountCode